import React from 'react';

import PropTypes from 'prop-types';

import icon from './crash.svg';

import './styles.css';

function ErrorBoundary({ reset }) {
  return (
    <div className="error">
      <img className="error-icon" src={icon} alt="Crashed" />

      <h1 className="error-title">
        Oops... Desculpe, ocorreu um erro inesperado na construção da página
      </h1>

      <button className="error-btn" onClick={reset}>
        Clique aqui para reiniciar
      </button>
    </div>
  );
}

ErrorBoundary.propTypes = {
  reset: PropTypes.func.isRequired,
};

export default ErrorBoundary;
